module.exports = __webpack_public_path__ + "static/plans-img-2-b1b20b115d51fbc64cb72c799477c15b.png";